import React from "react";
import { useTranslation } from "react-i18next";

export default function PastTripSummaryFilters({
  pastSummary,
  analyticsFilters,
  analyticsView,
}) {
  const { t } = useTranslation();
  const {
    filteredAnalyticsEvents,
    analyticsVisibleFilters,
    analyticsViewOptions,
    analyticsRows,
    analyticsUniqueDays,
    analyticsMaxCount,
    hasAnalyticsData,
    hasActiveAnalyticsFilters,
    clearAnalyticsFilters,
    setAnalyticsFilterValue,
    setAnalyticsViewValue,
  } = pastSummary;

  return (
    <div className="mytrips-past-summary-section mytrips-past-summary-section--filters">
      <div className="mytrips-past-analytics-header">
        <div>
          <h4 className="mytrips-past-summary-section-title">
            {t("trip_catch_analytics", {
              defaultValue: "Catch Analytics",
            })}
          </h4>
          <p className="mytrips-past-analytics-summary">
            {filteredAnalyticsEvents.length > 0
              ? t("trip_analytics_summary", {
                  defaultValue:
                    "Showing {{count}} catches across {{days}} trip days.",
                  count: filteredAnalyticsEvents.length,
                  days: analyticsUniqueDays,
                })
              : t("trip_analytics_summary_empty", {
                  defaultValue:
                    "No catches match the current analytics filters.",
                })}
          </p>
        </div>

        {hasActiveAnalyticsFilters && (
          <button
            type="button"
            className="mytrips-past-analytics-clear"
            onClick={clearAnalyticsFilters}
          >
            {t("clear_filters", {
              defaultValue: "Clear Filters",
            })}
          </button>
        )}
      </div>

      {hasAnalyticsData ? (
        <>
          {analyticsVisibleFilters.length > 0 && (
            <div className="mytrips-past-analytics-filters">
              {analyticsVisibleFilters.map((filter) => (
                <label
                  key={filter.key}
                  className="mytrips-past-analytics-filter"
                >
                  <span className="mytrips-past-analytics-filter-label">
                    {filter.label}
                  </span>
                  <select
                    className="mytrips-past-analytics-select"
                    value={analyticsFilters[filter.key] || ""}
                    onChange={(event) =>
                      setAnalyticsFilterValue(filter.key, event.target.value)
                    }
                  >
                    <option value="">{t("all", { defaultValue: "All" })}</option>
                    {filter.options.map((option) => {
                      const value =
                        typeof option === "string" ? option : option.value;
                      const label =
                        typeof option === "string" ? option : option.label;

                      return (
                        <option key={`${filter.key}-${value}`} value={value}>
                          {label}
                        </option>
                      );
                    })}
                  </select>
                </label>
              ))}
            </div>
          )}

          <div className="mytrips-past-analytics-views">
            {analyticsViewOptions.map((view) => (
              <button
                key={view.value}
                type="button"
                className={`mytrips-past-analytics-view${
                  analyticsView === view.value ? " is-active" : ""
                }`}
                onClick={() => setAnalyticsViewValue(view.value)}
              >
                {view.label}
              </button>
            ))}
          </div>

          {analyticsRows.length > 0 ? (
            <div className="mytrips-past-analytics-chart">
              {analyticsRows.map((row) => {
                const width =
                  analyticsMaxCount > 0
                    ? Math.max(8, Math.round((row.count / analyticsMaxCount) * 100))
                    : 0;

                return (
                  <div
                    key={row.key}
                    className="mytrips-past-analytics-row"
                  >
                    <div className="mytrips-past-analytics-row-head">
                      <div className="mytrips-past-analytics-row-copy">
                        <span className="mytrips-past-analytics-row-label">
                          {row.label}
                        </span>
                        {row.sublabel && (
                          <span className="mytrips-past-analytics-row-sublabel">
                            {row.sublabel}
                          </span>
                        )}
                      </div>
                      <span className="mytrips-past-analytics-row-count">
                        {row.count}
                      </span>
                    </div>
                    <div className="mytrips-past-analytics-bar">
                      <span
                        className="mytrips-past-analytics-bar-fill"
                        style={{ width: `${width}%` }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="mytrips-past-summary-empty">
              {t("trip_analytics_no_filtered_data", {
                defaultValue:
                  "No analytics data matches the current filters.",
              })}
            </p>
          )}
        </>
      ) : (
        <p className="mytrips-past-summary-empty">
          {t("trip_analytics_unavailable", {
            defaultValue: "Analytics data is not available for this trip yet.",
          })}
        </p>
      )}
    </div>
  );
}
